import { useQuery } from '@tanstack/react-query';
import { getPaymentMethod } from '@api/billing';

export function usePaymentMethod() {
  return useQuery({
    queryKey: ['billing', 'payment-method'],
    queryFn: getPaymentMethod,
    staleTime: 60_000,
  });
}
